import { render } from "./LessonPanel.vue?vue&type=template&id=04dcd87c"
import script from "./LessonPanel.vue?vue&type=script&lang=js"
export * from "./LessonPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__